import { render } from "./EcosistemasModal.vue?vue&type=template&id=7d27ea8d&scoped=true"
import script from "./EcosistemasModal.vue?vue&type=script&lang=js"
export * from "./EcosistemasModal.vue?vue&type=script&lang=js"

import "./EcosistemasModal.vue?vue&type=style&index=0&id=7d27ea8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d27ea8d"]])

export default __exports__